import { api } from "../../../infra/api";
import { Paginate } from "../../../infra/paginate";
import { URLS } from "../../../infra/URLS";
import { Cliente } from "../types/Clientes";

export async function getClienteModulo(ClienteId: number): Promise<any | any> {
  const resultJson = await api
    .get(URLS.CLIENTE_ID_API.replace("id", ClienteId.toString()))
    .then((resp) => resp.data);
  return resultJson;
}

export async function getClientes(search?: string, page = 1) {
  const { data } = await api.get<Paginate<Cliente>>(
    `${URLS.CLIENTES_API}`, {
      params: {page, search}
    });

  return data;
}

export async function getAllClientes(search? : string) {
  const size = await api
    .get(
      search ? `${URLS.CLIENTES_API}?search=${search}`: URLS.CLIENTES_API
    )
    .then((resp) => resp.data.meta);

  const resultJson = await api
    .get(
      `${URLS.CLIENTES_API}?${search ? 'search' : 'limit'}=${search ? search : size.totalItems}`
    )
    .then((resp) => resp.data.items);
  
  const result = resultJson.map((cliente: Cliente) => ({
    key: cliente.ClienteId,
    Id: cliente.ClienteId,
    Nome: cliente.Nome,
    Telefone: cliente.TelefoneComercial,
    Email: cliente.EmailPrincipal
  }));

  return result;
}
